import { render, staticRenderFns } from "./PanelChatInitialOptions.vue?vue&type=template&id=4b91c626"
import script from "./PanelChatInitialOptions.vue?vue&type=script&lang=js"
export * from "./PanelChatInitialOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports